query UserEdit($id: ID!) {
  user(id: $id) {
    id
    email
    phone
    firstName
    lastName
    middleName
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    isSuperAdmin
    country
    timeZone
    language
    agreeToMarketingNewsletters
    isPartner
    platformId
    platform {
      id
      title
    }
    currentOrganizationId
    currentOrganization {
      id
      title
    }
  }
}
